import { StepAction } from 'Components/buttons/stepButton';
import FormCompletionActions from './constants';
import { IActionObject } from './types';

// Sets form completion to true
export function setFormCompletionTrue(stepAction: StepAction): IActionObject {
  return {
    type: FormCompletionActions.SET_FORM_COMPLETION,
    data: { completed: true, stepAction },
  };
}

// Sets form completion to false
export function setFormCompletionFalse(): IActionObject {
  return {
    type: FormCompletionActions.SET_FORM_COMPLETION,
    data: { completed: false },
  };
}
try {
    // @ts-ignore
    setFormCompletionTrue.displayName = "setFormCompletionTrue";
    // @ts-ignore
    setFormCompletionTrue.__docgenInfo = { "description": "", "displayName": "setFormCompletionTrue", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/formCompletion/actions.tsx#setFormCompletionTrue"] = { docgenInfo: setFormCompletionTrue.__docgenInfo, name: "setFormCompletionTrue", path: "src/store/formCompletion/actions.tsx#setFormCompletionTrue" };
}
catch (__react_docgen_typescript_loader_error) { }